import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

import * as S from '../styled';

type Props = {
  active: boolean;
  content: {
    title: string;
  };
  onToggle: { (): void };
};

const Fold = ({
  active,
  content,
  onToggle,
}: Props) => (
  <S.Fold>
    <S.Title
      active={active}
      onClick={onToggle}
    >

      {active ? (
        <SVG.ChevronDown size={16} />
      ) : (
        <SVG.ChevronRight size={16} />
      )}
      <Text size="18px">
        {content.title}
      </Text>
      {content.subTitle && (
        <Text
          size="14px"
          color="#121827"
        >
          {content.subTitle}
        </Text>
      )}
    </S.Title>
    {active && (
      <Flex
        width="100%"
        padding="0 0 0 20px"
        column
      >
        {typeof content.inner === 'function' ? content.inner() : content.inner}
      </Flex>
    )}
  </S.Fold>
);

export default Fold;
